import CommandeView from "@features/achats/components/commandes/CommandeView";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";

export const Route = createFileRoute("/_app/achats/commandes/$id/view")({
  staticData: {
    title: "Détails Commande",
    icon: FileText,
    permission: PERMISSIONS.ACHATS.COMMANDES.VIEW,
    module: "achats",
    showInTab: false,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: CommandeView,
});
